import { EmblaOptionsType } from "embla-carousel"
import useEmblaCarousel from "embla-carousel-react"
import { useEffect, useState } from "react"

// https://www.embla-carousel.com/api/options/
export const emblaOptions: EmblaOptionsType = {
  // loop: true,
  skipSnaps: true,
  slidesToScroll: "auto",
  align: "start",
}

export function useEmbla(overrides?: EmblaOptionsType) {
  const [ref, embla] = useEmblaCarousel({ ...emblaOptions, ...overrides })
  const [scrollSnaps, setScrollSnaps] = useState<number[]>([])
  const [activeIndex, setActiveIndex] = useState(0)
  const [hasPrev, setHasPrev] = useState(false)
  const [hasNext, setHasNext] = useState(false)
  const [justifyCenter, setJustifyCenter] = useState(false)

  useEffect(() => {
    if (!embla) return

    const update = () => {
      const options = embla.internalEngine().options
      const scrollSnaps = embla.scrollSnapList()
      const watchDrag = scrollSnaps.length > 1

      if (watchDrag !== options.watchDrag) {
        embla.reInit({ ...options, watchDrag })
      }

      const activeIndex = embla.selectedScrollSnap()
      const hasPrev = embla.canScrollPrev()
      const hasNext = embla.canScrollNext()
      const justifyCenter = !hasPrev && !hasNext

      setScrollSnaps(scrollSnaps)
      setActiveIndex(activeIndex)
      setHasPrev(hasPrev)
      setHasNext(hasNext)
      setJustifyCenter(justifyCenter)
    }

    update()

    embla.on("reInit", update)
    embla.on("select", update)
  }, [embla])

  return {
    ref,
    embla,
    scrollSnaps,
    activeIndex,
    hasPrev,
    hasNext,
    justifyCenter,
  }
}
